<template>
  <div style="clear: both">
    <v-form ref="newsForm" v-model="valid">
      NEWS:
      <div v-for="(cn, index) in communityNews" v-bind:key="index">
        <v-row dense>
          <v-col cols="12">
            <v-card color="grey-lighten-2" class="ma-5 px-5" elevation="2" rounded="shaped">
              <v-card-title class="text-h5">
                {{ cn.abbrev }}
              </v-card-title>
              <div v-if="(cn.news || []).length > 0">
                <vueper-slides
                  :autoplay="cn.news.length > 1"
                  :pause-on-hover="pauseOnHover"
                  fixed-height="50px"
                  :bulletsOutside="true"
                  :touchable="false"
                >
                  <template #arrow-left>
                    <v-icon dark>mdi-chevron-left</v-icon>
                  </template>

                  <template #arrow-right>
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </template>
                  <vueper-slide v-for="(item, index) in cn.news" :key="index" :content="item.message" :style="item.style" />
                </vueper-slides>
              </div>

              <div v-if="(cn.news || []).length == 0">No News</div>

              <Draggable
                v-model="cn.news"
                :group="cn.abbrev"
                @start="drag = true"
                @end="
                  newsItemOrderChanged($event, cn);
                  drag = false
                "
                :disabled="newsSortDisabled"
              >
                <v-card
                  style="cursor: grab"
                  :style="index != cn.news.length - 1 ? 'border-bottom: 0px;' : ''"
                  v-for="(n, index) in cn.news || []"
                  v-bind:key="index"
                  elevation="2"
                  outlined
                  tile
                >
                  <v-container fluid>
                    <v-row class="mx-0">
                      <v-col cols="5" sm="5">
                        <v-text-field
                          v-model="n.message"
                          variant="underlined"
                          :value="n.message"
                          label="Message"
                          :readonly="cn.news[index].edit !== true"
                          :rules="[rules.required, rules.counter]"
                          :prepend-icon="newsSortDisabled ? '' : 'mdi-unfold-more-horizontal'"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="2" sm="1">
                        <v-text-field v-if="cn.news[index].edit !== true" variant="underlined" :model-value="n.type" label="Type" readonly></v-text-field>
                        <v-select
                          v-else
                          :model-value="n.type"
                          variant="underlined"
                          :items="newsTypes"
                          label="Type"
                          @update:modelValue="setNewsItemColor(cn, index, $event)"
                          :readonly="cn.news[index].edit !== true"
                          :rules="[rules.required]"
                        ></v-select>
                      </v-col>

                      <v-col cols="2" sm="2">
                        
                        <v-menu
                          v-model="menuEnd[index]"
                          :close-on-content-click="false"
                          
                          transition="scale-transition"
                          
                          
                          :disabled="cn.news[index].edit !== true"
                        >
                        
                          <template v-slot:activator="{ props }">
                            <v-badge bordered color="error"  :model-value="isExpired(cn, index)">
                              <v-text-field
                                :model-value="$filters.DateFilter(cn.news[index].endDate)"
                                label="End After Date"
                                variant="underlined"
                                readonly
                                min-width="200"
                                v-bind="props"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-badge>
                          </template>
                          <v-date-picker
                            :model-value="getDateObject(cn.news[index].endDate)"
                            :hide-header="true"
                            :min="new Date(minEndDate)"
                            @update:modelValue="updateEndDateValue(cn, $event, index)"
                          ></v-date-picker>
                       


                        </v-menu>




                      </v-col>

                      <v-col cols="2" sm="1">
                        <v-text-field readonly type="number" variant="underlined" label="Display Order" :model-value="index"></v-text-field>
                      </v-col>

                      <v-col cols="2" sm="1">
                        <v-text-field :label="$t('Community')" variant="underlined" :model-value="n.community" readonly></v-text-field>
                      </v-col>

                      <v-col cols="2" sm="2">
                        <div v-show="cn.news[index].edit !== true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ props }">
                              <v-fab
                                class="mx-2"
                                size="small"
                                :disabled="(cn.news || []).some((n) => n.edit == true)"
                                @click="deleteNewsItem(cn, cn.news[index].id, index)"
                                v-bind="props"
                                icon="mdi-delete-outline"
                              >
                                
                              </v-fab>
                            </template>
                            <span>{{ $t('Delete') }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ props }">
                              <v-fab
                                class="mx-2"
                                size="small"
                                @click="toggleNewsItemEditable(cn, index, true)"
                                :disabled="(cn.news || []).some((n) => n.edit == true)"
                                v-bind="props"
                                icon="mdi-pencil"
                              
                              >
                              </v-fab>
                            </template>
                            <span>{{ $t('Edit') }}</span>
                          </v-tooltip>
                        </div>

                        <div v-show="cn.news[index].edit === true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ props }">
                              <v-fab 
                              class="mx-2" 
                               
                              size="small" 
                              @click="save(cn, index)" 
                              icon="mdi-content-save"
                              :disabled="!valid">
                                
                              </v-fab>
                            </template>
                            <span>{{ $t('Save') }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ props }">
                              <v-fab 
                              class="mx-2" 
                              icon="mdi-close-circle-outline" 
                              v-bind="props"
                              small @click="load()">
                              </v-fab>
                            </template>
                            <span>{{ $t('Cancel') }}</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </Draggable>
 
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" class="btn-plus elevation-10" icon="mdi-plus" 
                      :disabled="(cn.news || []).some((n) => n.edit == true)" @click="addNewsItem(cn)">
                    </v-btn>
                  </template>
                  <span>{{ $t('Add') }} to {{ cn.abbrev }}</span>
                </v-tooltip>
              </v-card-actions>

            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-form>
    <toaster ref="toaster"></toaster>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import MOCAdminService from '@/services/admin.service'
import NewsService from '@/services/news.service'
import moment from 'moment'
import Toaster from '@/components/Toaster'
import { VueDraggableNext } from 'vue-draggable-next'
import DateFilter from '../filters/date'

export default {
  name: 'NewsAdmin',
  data() {
    return {
      valid: false,
      menuEnd: [false],
      news: [],
      communityNews: [],
      newsSortDisabled: false,
      newsTypes: ['Important', 'Warning', 'General'].sort(),
      communities: [],

      communityAbbreviations: [],
      options: {
        currentPage: 0,
        thresholdDistance: 500,
        thresholdTime: 100,
        autoplay: 2000,
        loop: true,
        loopedSlides: 1,
        slidesToScroll: 1,
        timingFunction: 'ease',
        speed: 300
      },
      pauseOnHover: true,
      rules: {
        required: (v) => !!v || 'Required',
        counter: (v) => v.length <= 200 || 'Max 200 characters'
      }
    }
  },
  components: {
    Draggable: VueDraggableNext,
    VueperSlides,
    VueperSlide,
    Toaster,
  },
  methods: {
    getDateObject(dataString){
      if (dataString)
        return new Date(dataString)
      return new Date()
    },
    addNewsItem(cn) {
      cn.news.push({
        id: null,
        message: '',
        type: 'General',
        endDate: '',
        community: cn.abbrev.toUpperCase(),
        order: cn.news.length - 1,
        style: {
          background: '#388E3C'
        },
        edit: true
      })

      this.$nextTick(() => {
        let self = this
        self.$refs.newsForm.validate()
      })
    },
    deleteNewsItem(cn, id, index) {
      if (id != null) {
        return new Promise((resolve, reject) => {
          NewsService.deleteNewsItem(id)
            .then(() => {
              this.$refs.toaster.pop('success', 'News item deleted successfully')
              resolve()
            })
            .catch((e) => {
              this.$refs.toaster.pop('error', 'Could not delete News item')
              reject(e)
            })
            .finally(() => {
              cn.news.splice(index, 1)
            })
        })
      }
    },
    isExpired(cn, index) {
      if (moment().endOf('day').diff(cn.news[index].endDate, 'days') >= 1) {
        return true
      }
      return false
    },
    load() {
      this.communityNews = []
      return new Promise((resolve, reject) => {
        NewsService.getNewsForEdit()
          .then((data) => {
            this.communityNews = data
            resolve()
          })
          .catch((e) => {
            this.$refs.toaster.pop('error', 'Could not load News')
            reject(e)
          })
          .finally(() => {
            this.communityNews.forEach((c) => {
              for (let i = 0; i < c.news.length; i++) {
                this.setNewsItemColor(c, i)
              }
            })

            this.newsSortDisabled = false
          })
      })
    },
    newsItemOrderChanged(evt, cn) {
      let count = 0
      cn.news.forEach((n) => {
        n.order = count++
      })

      this.saveAll(cn)
    },
    toggleNewsItemEditable(cn, index, boolIn) {
      cn.news[index].edit = boolIn
      this.newsSortDisabled = boolIn
      this.$forceUpdate()
    },
    save(cn, index) {
      let self = this
      if (self.$refs.newsForm.validate()) {
        NewsService.save([cn.news[index]])
          .then((result) => {
            if (!result.success) {
              this.$refs.toaster.pop('error', 'Error saving News item')
            }
          })
          .then(() => {
            this.$refs.toaster.pop('success', 'News item saved')
          })
          .catch((e) => {
            this.$refs.toaster.pop('error', 'Error saving News item')
          })
          .finally(() => {
            this.toggleNewsItemEditable(cn, index, false)
          })
      }
    },
    saveAll(cn) {
      let self = this
      if (self.$refs.newsForm.validate()) {
        NewsService.save(cn.news)
          .then((result) => {
            if (!result.success) {
              this.$refs.toaster.pop('error', 'Error saving News item order')
            }
          })
          .then(() => {
            this.$refs.toaster.pop('success', 'News item order saved')
          })
          .catch((e) => {
            this.$refs.toaster.pop('error', 'Error saving News item order')
          })
      }
    },
    setNewsItemColor(cn, index, type) {
      if (cn.news[index]) {
        if (type) {
          cn.news[index].type = type
        }

        let bg = '#388E3C'
        switch (cn.news[index].type) {
          case 'Important': {
            bg = '#c70000'
            break
          }
          case 'Warning': {
            bg = '#FFBA01'
            break
          }
        }

        cn.news[index].style = cn.news[index].style || {}
        cn.news[index].style.background = cn.news[index].style.background || {}
        cn.news[index].style.background = bg

        this.$forceUpdate()
      }
    },
    updateEndDateValue(cn, value, index) {
      this.menuEnd[index] = false
      cn.news[index].endDate = moment(value).format()
    }
  },
  computed: {
    ...mapState('currentUserAdminRoles', ['adminRoles']),
    
    minEndDate() {
      return moment().add(1, 'day').endOf('day').format()
    }
    
  },
  watch: {
    communities() {
      console.log(`news.vue watch communities`)
      if (this.adminRoles.find((x) => x === 'ProcessManager' || x === 'ITSupport')) {
        this.communityAbbreviations = ['ALL*'].concat((this.communities || []).map((c) => c.communityAbbreviation.toUpperCase()))
      } else {
        this.communityAbbreviations = (this.communities || []).map((c) => c.communityAbbreviation.toUpperCase())
      }
    }
  },
  mounted() {
    this.load()
  },
  created() {
    if (this.loading) return
    this.loading = true
    MOCAdminService.getUserCommunities()
      .then(
        (succ) =>
          (this.communities = [
            ...succ.sort((a, b) => (a.communityAbbreviation.toUpperCase() > b.communityAbbreviation.toUpperCase() ? 1 : -1))
          ])
      )
      .catch(() => {})
      .finally(() => (this.loading = false))
  }
}
</script>

<style scoped>
.btn-plus {
  height: 60px;
  width: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
  background-color: #4caf50 !important;
  color: #FFFFFF;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);;
}
</style>